/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: []
  },
}
/* eslint-enable */
